import { Component } from '@angular/core';

import { BaseIconComponent } from '../base-icon.component';

@Component({
  selector: 'app-business-health-insurance-icon',
  template: `
    <svg
      [attr.width]="width"
      [attr.height]="height"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_522_2370)">
        <path
          d="M7.5 18.75C8.74264 18.75 9.75 17.7426 9.75 16.5C9.75 15.2574 8.74264 14.25 7.5 14.25C6.25736 14.25 5.25 15.2574 5.25 16.5C5.25 17.7426 6.25736 18.75 7.5 18.75Z"
          [attr.stroke]="color"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M12 14.25H20.5C21.0304 14.25 21.5391 14.4607 21.9142 14.8358C22.2893 15.2109 22.5 15.7196 22.5 16.25V18.75H12V14.25Z"
          [attr.stroke]="color"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M22.5 18.75H1.5V21.75H22.5V18.75Z"
          [attr.stroke]="color"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M1.5 23.25V14.25"
          [attr.stroke]="color"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M22.5 23.25V21.75"
          [attr.stroke]="color"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M17.25 3.75H15V1.5C15 1.30109 14.921 1.11032 14.7803 0.96967C14.6397 0.829018 14.4489 0.75 14.25 0.75H11.25C11.0511 0.75 10.8603 0.829018 10.7197 0.96967C10.579 1.11032 10.5 1.30109 10.5 1.5V3.75H8.25C8.05109 3.75 7.86032 3.82902 7.71967 3.96967C7.57902 4.11032 7.5 4.30109 7.5 4.5V7.5C7.5 7.69891 7.57902 7.88968 7.71967 8.03033C7.86032 8.17098 8.05109 8.25 8.25 8.25H10.5V10.5C10.5 10.6989 10.579 10.8897 10.7197 11.0303C10.8603 11.171 11.0511 11.25 11.25 11.25H14.25C14.4489 11.25 14.6397 11.171 14.7803 11.0303C14.921 10.8897 15 10.6989 15 10.5V8.25H17.25C17.4489 8.25 17.6397 8.17098 17.7803 8.03033C17.921 7.88968 18 7.69891 18 7.5V4.5C18 4.30109 17.921 4.11032 17.7803 3.96967C17.6397 3.82902 17.4489 3.75 17.25 3.75Z"
          stroke="#00D5D3"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_522_2370">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  `,
})
export class BusinessHealthInsuranceIconComponent extends BaseIconComponent {}
